import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export function ActivityIcon(props: SVGProps): JSX.Element {
  return <SpriteIcon spriteId="activity" {...props} />;
}
